module.exports = {
      id: "nepal-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#nepal-flag",
      toString: function () {
        return this.url;
      }
    }